/* eslint-disable camelcase */
import React from 'react'
import { IconButton, Typography } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp';
import { postPqrsFiles } from '@auteco/services/finderServices';
import { dateToLocal } from '@auteco/utils/dateToLocal';
import useStyles from './styles'

const File = ({ file }) => {
    const classes = useStyles()


    const signFile = async ({ url }) => {
        const body = {
            attachment_url: url
        }
        const { attachment_url } = await postPqrsFiles({ params: body })
        if (attachment_url !== '') {
            const stringSplit = attachment_url.split('?')
            const decodedUrl = decodeURIComponent(stringSplit[1]);
            const concat = `${stringSplit[0]}?${decodedUrl}`
            window.open(concat, '_blank');
        }
    }

    return (
        <div className={classes.file}>
            <IconButton className={classes.iconBtn} onClick={() => signFile({ url: file.attachment_url })} ><GetAppIcon /></IconButton>
            <Typography style={{ maxWidth: '95%' }}><span className={classes.title}>Nombre:</span> {file["content-file-name"]}</Typography>
            <Typography><span className={classes.title}>Id:</span> {file.id}</Typography>
            <Typography><span className={classes.title}>Fecha de creación:</span> {dateToLocal(file["created-at"]).formattedDateAndHour}</Typography>
        </div >
    )
}

export { File }